export default {
  loading: false,
  nationOptions: []
};
